import AxiosInstance from "./api";

export const VatExemptionReductionService = {
  create: async (payload) => {
    return await AxiosInstance.post("/private/vat-exemption-reduction-transaction", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.put(`/private/vat-exemption-reduction-transaction/${id}`, payload);
  },
  paginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/vat-exemption-reduction-transaction/paginate", {
      params: query,
    });
  },
  init: async () => {
    return await AxiosInstance.get("/private/vat-exemption-reduction-transaction/init");
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/vat-exemption-reduction-transaction/${id}`);
  },
  remove: async (id) => {
    return await AxiosInstance.delete(`/private/vat-exemption-reduction-transaction/${id}`);
  },
};
